export default __webpack_public_path__ + "static/media/bestatter_film_image.5807481e.png";